import { render } from "./HeaderAuthActions.vue?vue&type=template&id=6c4c269f"
import script from "./HeaderAuthActions.vue?vue&type=script&lang=js"
export * from "./HeaderAuthActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__